import React, { useState } from 'react';
import { Collapse, Spin } from 'antd';
import { TableSecProps } from './props';
import { PrintSolicitacaoRetornoServices } from '../../services/solicitacoesRetornoServices';
import ListSteps from '../ListSteps';

const CardSecMobile: React.FC<TableSecProps> = ({ nuNota, props }) => {
  const { Panel } = Collapse;
  // eslint-disable-next-line
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await PrintSolicitacaoRetornoServices.getImprimeAutorizacaoEntrega(nuNota).then((res) => {
        setResponse(res.data.estoques);
      });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Collapse onChange={handleClick} key={nuNota}>
      <Panel header="Detalhes" key={nuNota}>
        {loading ? <Spin size="small" /> : <ListSteps record={props} />}
      </Panel>
    </Collapse>
  );
};

export default CardSecMobile;
